/* global API */

import { toRaw } from 'vue';

/**
 * CReate the GreenComp strings
 * @param {object} taxonomy Taxonomy to create the strings from
 */
export function useCreateGcStrings(taxonomy) {
	const gcArray = [];

	const parents = taxonomy.filter((term) => term.parent === 0);
	const parentIds = parents.map((parent) => parent.term_id);

	const children = taxonomy.filter((term) => parentIds.includes(term.parent));
	const childrenIds = children.map((child) => child.term_id);

	const grandchildren = taxonomy.filter((term) => childrenIds.includes(term.parent));

	if (grandchildren.length > 0) {
		grandchildren.forEach((grandchild) => {
			const gcObject = {
				gc_string: grandchild.description,
			};

			gcArray.push(gcObject);
		});
	}

	this.helpers.gcArray = gcArray;
}

/**
 * Get the GreenComp taxonomy from the API
 * @returns {Promise} GreenComp taxonomy
 */
export async function useGetGreencomp() {
	return fetch(`${API.url}/greencomp`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	})
		.then((res) => res.json())
		.then((response) => {
			this.results.gcParents = response?.filter((item) => item.parent === 0);

			this.results.gcParents.sort((a, b) => {
				if (a.prefix && b.prefix) {
					return a.prefix.localeCompare(b.prefix);
				}

				return 0;
			});

			this.results.gcChildren = response?.filter((item) =>
				this.results.gcParents.filter((parent) => parent.term_id === item.term_id),
			);

			this.results.gcChildren.sort((a, b) => {
				if (a.prefix && b.prefix) {
					return a.prefix.localeCompare(b.prefix);
				}

				return 0;
			});

			this.results.gcGrandchildren = response?.filter((item) =>
				this.results.gcChildren.filter((parent) => parent.term_id === item.term_id),
			);

			this.results.gcGrandchildren.sort((a, b) => {
				if (a.prefix && b.prefix) {
					return a.prefix.localeCompare(b.prefix);
				}

				return 0;
			});
		})
		.catch((error) => console.error('Error', error));
}

/**
 * Get the first GreenComp select
 * @param {boolean} array Return as array or not
 */
export function useGcFirstSelect(array = true) {
	this.helpers.greencomp.second = '';

	if (array) {
		this.helpers.greencomp.third = [];
	} else {
		this.helpers.greencomp.third = '';
	}
}

/**
 * Get the second GreenComp select
 * @param {boolean} array Return as array or not
 */
export function useGcSecondSelect(array = true) {
	if (array) {
		this.helpers.greencomp.third = [];
	} else {
		this.helpers.greencomp.third = '';
	}
}

/**
 * Add GreenComp to formData
 */
export function useAddGc() {
	const { first, second, third } = this.helpers.greencomp;

	const ids = [first.term_id, second.term_id];

	third.forEach((item) => {
		ids.push(item.term_id);

		const gcObject = {
			gc_string: item.description,
		};

		this.helpers.gcArray.push(gcObject);
	});

	// let gcString = `${first.name}, ${second.name}`;
	// let gcString = third.description;

	// third.forEach((item) => {
	//   ids.push(item.term_id);

	//   gcString += `, ${item.name}`;

	//   const gcObject = {
	//     gc_string: gcString,
	//   };

	//   this.helpers.gcArray.push(gcObject);
	// });

	this.formData.greencomp.push(ids.filter((id) => id !== undefined));

	const multiselect = document.querySelector('.gc-checkboxes.active');

	if (multiselect) {
		multiselect.style.display = 'none';
	}

	this.helpers.greencomp = {
		first: '',
		second: '',
		third: [],
	};
}

/**
 * Remove GreenComp from formData
 * @param {number} index Index to remove
 */
export function useRemoveGc(index) {
	this.helpers.gcArray.splice(index, 1);
	this.formData.greencomp.splice(index, 1);
}

/**
 * Get the material relevance
 * @param {object} element Element to get the relevance from
 * @returns {Array} Relevance strings
 */
export function useGetMaterialRelevance(element) {
	if (this.tab === 'laaja') {
		const strings = [];

		const { tavoite, vuosiluokka, oppiaine } = this.helpers.laajaObject;

		const tavoiteEntries = Object.entries(toRaw(this.data.ops));
		const slugs = [];

		// Get all slugs that match the tavoite
		tavoiteEntries.forEach((item) => {
			if (item[1].laajattavoitteet?.find((item2) => tavoite === item2.id)) {
				if (!slugs.includes(item[0])) {
					slugs.push(`${item[0]}_fi_fi`);
				}
			}
		});

		if (element.taxonomies.soveltuvuudet) {
			const values = Object.values(element.taxonomies.soveltuvuudet);
			const matches = values.filter((item) => slugs.includes(item.slug));

			matches.forEach((item) => {
				if (oppiaine && vuosiluokka) {
					const parents = this.useFindAllParents(values, item);

					const subjectIsRelevant = parents.find((parent) => parent.slug === oppiaine);
					const classIsRelevant = parents.find((parent) => parent.name === vuosiluokka);

					if (!subjectIsRelevant || !classIsRelevant) {
						return;
					}
				} else if (oppiaine) {
					const parents = this.useFindAllParents(values, item);

					const subjectIsRelevant = parents.find((parent) => parent.slug === oppiaine);

					if (!subjectIsRelevant) {
						return;
					}
				} else if (vuosiluokka) {
					const parents = this.useFindAllParents(values, item);

					const classIsRelevant = parents.find((parent) => parent.name === vuosiluokka);

					if (!classIsRelevant) {
						return;
					}
				}

				const regex = /(T\s*\d+)/;
				const match = item.descriptions[this.lang].match(regex);

				let shortString = '';
				let longString = item.descriptions[this.lang];

				if (match) {
					[shortString] = match;
				} else {
					shortString = item.descriptions[this.lang];
				}

				let parent = this.useFindParent(values, item.parent);

				if (parent) {
					shortString = `${parent.names[this.lang]}, ${shortString}`;
					longString = `${parent.names[this.lang]}, ${longString}`;

					while (parent.parent !== 0) {
						parent = this.useFindParent(values, parent.parent);

						if (!parent || !parent.names || !parent.names[this.lang]) {
							break;
						} else {
							shortString = `${parent.names[this.lang]}, ${shortString}`;
							longString = `${parent.names[this.lang]}, ${longString}`;
						}
					}
				}

				strings.push({
					short: shortString,
					long: longString,
				});
			});
		}

		return strings;
	}

	if (this.tab === 'ops') {
		const strings = [];

		const { subject } = this.helpers.subjectObject;
		const subjectClass = this.helpers.subjectObject.subject_class;
		const subjectTarget = this.helpers.subjectObject.subject_target;
		const subjectLang = this.helpers.subjectObject.subject_lang;
		const subjectArea = this.helpers.subjectObject.subject_area;

		const subjectName = subject?.names?.fi;
		const className = subjectClass?.names?.fi;

		if (this.weird_ones.includes(subjectName)) {
			// If subject is one of the weird ones
			if (className === 'Lukio') {
				// If class is "lukio"
				if (subjectTarget) {
					// If target is set
					strings.push({
						short: subjectTarget.descriptions[this.lang],
						long: subjectTarget.descriptions[this.lang],
					});
				} else if (subjectArea) {
					// If target is not set and area is set
					element.taxonomies?.soveltuvuudet.forEach((item) => {
						if (item.parent === subjectArea.term_id) {
							const string = this.useCreateRelevancyString(element, item);

							strings.push(string);
						}
					});
				} else if (subjectLang) {
					// If target and area is not set and lang is set
					const areas = element.taxonomies?.soveltuvuudet.filter((item) => {
						return item.parent === subjectLang.term_id;
					});

					const areaIds = areas.map((item) => item.term_id);

					element.taxonomies?.soveltuvuudet.forEach((item) => {
						if (areaIds.includes(item.parent)) {
							const string = this.useCreateRelevancyString(element, item);

							strings.push(string);
						}
					});
				} else if (subjectClass) {
					// If target, area and lang is not set and class is set
					const langs = element.taxonomies?.soveltuvuudet.filter((item) => {
						return item.parent === subjectClass.term_id;
					});

					const langIds = langs.map((item) => item.term_id);

					const areas = element.taxonomies?.soveltuvuudet.filter((item) => {
						return langIds.includes(item.parent);
					});

					const areaIds = areas.map((item) => item.term_id);

					element.taxonomies?.soveltuvuudet.forEach((item) => {
						if (areaIds.includes(item.parent)) {
							const string = this.useCreateRelevancyString(element, item);

							strings.push(string);
						}
					});
				}
			} else if (subjectTarget) {
				// If class is not "lukio" and target is selected
				const string = this.useCreateRelevancyString(element, subjectTarget);

				strings.push(string);
			} else if (subjectArea) {
				// If class is not "lukio", target is not selected and area is selected
				element.taxonomies?.soveltuvuudet.forEach((item) => {
					if (item.parent === subjectArea.term_id) {
						const string = this.useCreateRelevancyString(element, item);

						strings.push(string);
					}
				});
			} else if (subjectClass) {
				// If class is not "lukio", target is not selected, area is not selected and class is selected
				const areas = element.taxonomies?.soveltuvuudet.filter((item) => {
					return item.parent === subjectClass.term_id;
				});

				const areaIds = areas.map((item) => item.term_id);

				element.taxonomies?.soveltuvuudet.forEach((item) => {
					if (areaIds.includes(item.parent)) {
						const string = this.useCreateRelevancyString(element, item);

						strings.push(string);
					}
				});
			}
		} else if (subjectTarget) {
			const string = this.useCreateRelevancyString(element, subjectTarget);

			strings.push(string);
		} else if (subjectArea) {
			element.taxonomies?.soveltuvuudet.forEach((item) => {
				if (item.parent === subjectArea.term_id) {
					const string = this.useCreateRelevancyString(element, item);

					strings.push(string);
				}
			});
		} else if (subjectClass) {
			if (subjectClass.name === 'Lukio') {
				const areas = element.taxonomies?.soveltuvuudet.filter((item) => {
					return item.parent === subjectClass.term_id;
				});

				const areaIds = areas.map((item) => item.term_id);

				element.taxonomies?.soveltuvuudet.forEach((item) => {
					if (areaIds.includes(item.parent)) {
						const string = this.useCreateRelevancyString(element, item);

						strings.push(string);
					}
				});
			} else {
				element.taxonomies?.soveltuvuudet.forEach((item) => {
					if (item.parent === subjectClass.term_id) {
						const string = this.useCreateRelevancyString(element, item);

						strings.push(string);
					}
				});
			}
		} else if (subject) {
			const classes = element.taxonomies?.soveltuvuudet.filter((item) => {
				return item.parent === subject.term_id;
			});

			const classIds = classes.map((item) => item.term_id);

			const lukioChilds = [];
			const normalChilds = [];

			element.taxonomies?.soveltuvuudet.forEach((item) => {
				if (classIds.includes(item.term_id)) {
					if (item.name === 'Lukio') {
						lukioChilds.push(item);
					} else {
						normalChilds.push(item);
					}
				}
			});

			const lukioChildsIds = lukioChilds.map((item) => item.term_id);

			const lukioAreas = element.taxonomies?.soveltuvuudet?.filter((item) => {
				return lukioChildsIds.includes(item.parent);
			});

			const lukioAreaIds = lukioAreas.map((item) => item.term_id);
			const normalIds = normalChilds.map((item) => item.term_id);

			element.taxonomies?.soveltuvuudet?.forEach((item) => {
				if (normalIds.includes(item.parent) || lukioAreaIds.includes(item.parent)) {
					const string = this.useCreateRelevancyString(element, item);

					strings.push(string);
				}
			});
		}

		return strings;
	}

	if (this.tab === 'gc') {
		const { first, second, third } = this.helpers.greencomp;

		const strings = [];

		if (third) {
			element.taxonomies?.greencomp.forEach((item) => {
				if (item.term_id === third.term_id) {
					const string = {
						short: item.descriptions[this.lang],
						long: item.descriptions[this.lang],
					};

					strings.push(string);
				}
			});
		} else if (second) {
			const thirdTerms = element.taxonomies?.greencomp.filter((item) => {
				return item.parent === second.term_id;
			});

			if (thirdTerms) {
				element.taxonomies?.greencomp.forEach((item) => {
					if (item.parent === second.term_id) {
						const string = {
							short: item.descriptions[this.lang],
							long: item.descriptions[this.lang],
						};

						strings.push(string);
					}
				});
			}
		} else if (first) {
			const secondTerms = element.taxonomies?.greencomp.filter((item) => {
				return item.parent === first.term_id;
			});

			if (secondTerms) {
				const secondTermIds = secondTerms.map((item) => item.term_id);

				element.taxonomies?.greencomp.forEach((item) => {
					if (secondTermIds.includes(item.parent)) {
						const string = {
							short: item.descriptions[this.lang],
							long: item.descriptions[this.lang],
						};

						strings.push(string);
					}
				});
			}
		}

		return strings;
	}

	return false;
}

/**
 * Find parent from values
 * @param {Array} values Values to search from
 * @param {number} id ID to search
 * @returns {object} Found parent
 */
export function useFindParent(values, id) {
	return values.find((item) => item.term_id === id);
}

/**
 * Find all parents from values
 * @param {Array} values Values to search from
 * @param {object} item Item to search
 * @returns {object} Found parent
 */
export function useFindAllParents(values, item) {
	let parent = this.useFindParent(values, item.term_id);

	const parents = [];

	if (parent) {
		while (parent.parent !== 0) {
			parent = this.useFindParent(values, parent.parent);

			if (parent) {
				parents.push(parent);
			} else {
				parent = {
					parent: 0,
				};
			}
		}
	}

	return parents;
}

/**
 * Find all children from values
 * @param {Array} values Values to search from
 * @param {number} id ID to search
 * @returns {Array} Found children
 */
export function useFindAllChildren(values, id) {
	const matches = values.filter((item) => item.parent === id);

	const result = [];

	if (matches) {
		matches.forEach((match) => {
			result.push(toRaw(match));

			const children = this.useFindAllChildren(values, match.term_id);

			if (children.length > 0) {
				result.push(...children);
			}
		});
	}

	return result;
}

/**
 * Group the subjects
 */
export function useGroupSubjects() {
	const terms = [];
	const parents = this.results.subjects.filter((term) => term.parent === 0);

	parents.forEach((term) => {
		const children = this.useFindAllChildren(this.results.subjects, term.term_id);

		// Push parent and children to terms array
		terms.push([term, ...children]);
	});

	this.data.groupedSubjects = terms;
}

/**
 * Create a relevancy string
 * @param {object} element Element to create the string from
 * @param {object} item Item to create the string from
 * @returns {object} Relevancy strings
 */
export function useCreateRelevancyString(element, item) {
	const parents = this.useFindAllParents(element.taxonomies?.soveltuvuudet, item);

	let shortString = '';

	parents?.reverse().forEach((parent) => {
		shortString += `${parent.names[this.lang]}, `;
	});

	const longString = shortString + item.descriptions[this.lang];

	const regex = /(T\s*\d+)/;
	const match = item.descriptions[this.lang].match(regex);

	if (match) {
		shortString += match[0];
	} else {
		shortString += item.descriptions[this.lang];
	}

	return {
		short: shortString,
		long: longString,
	};
}

/**
 * Creae the laaja options for the select
 */
export function useCreateLaajaOptions() {
	const subjects = this.results.subjects?.filter((term) => term.parent === 0);

	const classTerms = {};

	this.results.subjects.filter((term) =>
		subjects.forEach((parent) => {
			if (parent.term_id === term.parent) {
				if (typeof classTerms[term.name] === 'undefined') {
					classTerms[term.name] = {
						names: term.names,
						terms: [],
					};
				}

				classTerms[term.name].terms.push(term.slug);
			}
		}),
	);

	this.data.subjectTerms = subjects;
	this.data.classTerms = classTerms;
}

/**
 * Get the laaja slugs
 * @param {number} tavoite Tavoite to search for
 * @returns {Array} Found slugs
 */
export function useGetLaajaSlugs(tavoite) {
	const tavoiteEntries = Object.entries(toRaw(this.data.ops));
	const slugs = [];

	tavoiteEntries.forEach((item) => {
		if (item[1].laajattavoitteet?.find((item2) => tavoite === item2.id)) {
			if (!slugs.includes(item[0])) {
				slugs.push(`${item[0]}_fi_fi`);
			}
		}
	});

	return slugs;
}

/**
 * Get the subject term by slug
 * @param {string} slug Slug to search for
 * @returns {object} Found subject term
 */
export function useGetSubjectTerm(slug) {
	return this.results.subjects.find((term) => term.slug === slug);
}

/**
 * Get the subject parents by term object
 * @param {object} term Term object to search from
 * @returns {Array} Found parents
 */
export function useGetSubjectParents(term) {
	const values = this.results.subjects;

	let parent = this.useFindParent(values, term.term_id);

	const parents = [];

	if (parent) {
		while (parent.parent !== 0) {
			parent = this.useFindParent(values, parent.parent);

			if (parent) {
				parents.push(parent);
			}
		}
	}

	return parents;
}

/**
 * Get the GreenComp term by slug
 * @param {string} slug Slug to search for
 * @param {string} position Position to search from, parents, children or grandchildren
 * @returns {object} Found GreenComp term
 */
export function useGetGcBySlug(slug, position) {
	if (position === 'parents') {
		return this.results.gcParents?.find((item) => item.slug === slug);
	}

	if (position === 'children') {
		return this.results.gcChildren?.find((item) => item.slug === slug);
	}

	if (position === 'grandchildren') {
		return this.results.gcGrandchildren?.find((item) => item.slug === slug);
	}

	return false;
}
